import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Element from "element-ui";

import locale from "element-ui/lib/locale/lang/es";
import "element-ui/lib/theme-chalk/index.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

Vue.use(Element,{
  locale,
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
